import { render, staticRenderFns } from "./addConfigWeek.vue?vue&type=template&id=3d11bf05&scoped=true"
import script from "./addConfigWeek.vue?vue&type=script&lang=js"
export * from "./addConfigWeek.vue?vue&type=script&lang=js"
import style0 from "./addConfigWeek.vue?vue&type=style&index=0&id=3d11bf05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d11bf05",
  null
  
)

export default component.exports